







import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class UiDefinitionBoxComponent extends Vue {

  @Prop()
  public definitionTitle: string;

  @Prop()
  public definitionText: string;
}
